export default "__VITE_ASSET__BrxWkboJ__"